import React from "react";
import { motion, AnimatePresence } from "framer-motion";
import styles from "./styles.module.scss";
import { ChevronDown } from "react-bootstrap-icons";
import { Text } from "../../styledComponent";

const FaqBox = ({ id, title, description, currentFaq, currentQues, pointers = [] }) => {
  
  return (
    <li
      className={
        currentQues ? `${styles.activeFaq} ${styles.faqBox}` : styles.faqBox
      }
      onClick={() => {
        currentQues ? currentFaq(false) : currentFaq(id)
      }}
    >
      <motion.button
        initial={false}
        className={styles.faqHeader}
        whileTap={{ scale: 0.97 }}
      >
        <span>{title}</span>
        <span>
          <ChevronDown size={15} />
        </span>
      </motion.button>
      <AnimatePresence initial={false}>
        {currentQues && (
          <motion.div
            className={styles.faqBody}
            key="content"
            initial="collapsed"
            animate="open"
            exit="collapsed"
            variants={{
              open: { opacity: 1, height: "auto" },
              collapsed: { opacity: 0, height: 0 },
            }}
            transition={{ duration: 0.8, ease: [0.04, 0.62, 0.23, 0.98] }}
          >
            {description && <Text>{description}</Text>}
            {pointers.length > 0 && (
              <ul className={styles.pointersList}>
                {pointers.map((pointer, index) => (
                  <li key={index}>{pointer}</li>
                ))}
              </ul>
            )}
          </motion.div>
        )}
      </AnimatePresence>
    </li>
  );
};

export default FaqBox;
